module.exports = __webpack_public_path__ + "img/file-icon.d7299529.svg";